import { gql } from 'urql';

const TransferReviewDetailsQuery = gql`
  query TransferReviewDetails($input: TransferReviewDetailsInput!) {
    transferReviewDetails(input: $input) {
      __typename
      ... on TransferReviewDetails {
        rail
        title
        disclaimer
        transferQuoteToken
        sections {
          id
          title
          items {
            primaryText
            secondaryText
            primaryNumberOfLines
            boldPrimaryCopy
            lineFormat
            isDisabled
            showsChevron
            accessibilityLabel
            trailingAccessory {
              __typename
              ... on VxlListItemTrailingTextAccessory {
                primaryCopy
                secondaryCopy
                boldPrimaryCopy
                primaryNumberOfLines
              }
            }
          }
        }
      }
      ... on TransferReviewDetailsError {
        code
        errorTitle: title
        message
        errorCode
      }
    }
  }
`;

export default TransferReviewDetailsQuery;
